<div class="results-container">
  @if (dropDownCategories$().length > 2) {
    <mat-form-field subscriptSizing="dynamic">
      <mat-select (ngModelChange)="onCategoryChange($event)" [ngModel]="selectedCategoryRef$()">
        @for (button of dropDownCategories$(); track $index) {
          <mat-option [value]="button.ref">
            {{ button.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <ul class="uk-tab" data-uk-tab="{connect:'#tab-results'}">
    <li
      id="indicators"
      [class.uk-active]="tabSelected$() === tabIndicators"
      (click)="tabSwitch(tabIndicators)"
    >
      <a href="#">INDICATORS</a>
    </li>
    <!-- @todo, should add disable: [class.uk-disabled] -->
    <li id="charts" [class.uk-active]="tabSelected$() === tabCharts" (click)="tabSwitch(tabCharts)">
      <a href="#">CHARTS</a>
    </li>
  </ul>

  <div>
    <!-- INDICATORS -->
    @if (tabSelected$() === tabIndicators) {
      <table class="uk-table uk-table-small indicators-table">
        <thead>
          <tr>
            <th>Information</th>
            <th>Value</th>
          </tr>
        </thead>

        <!-- Layer Results With Data -->

        @if (isCMRunning$() || isLayerResultsLoading$()) {
          <tr>
            <td colspan="2">
              <div class="uk-text-center uk-margin-small">
                <div uk-spinner="ratio: 3"></div>
              </div>
            </td>
          </tr>
        }

        @if (filteredLayers$().length > 0) {
          @for (layer of filteredLayers$(); track $index) {
            <tr class="title-row">
              <td colspan="2">{{ layer.name | businessNameLayer }}</td>
            </tr>
            @if (layer.values.length == 0) {
              <tr class="no-indicators-row">
                <td colspan="2"><span uk-icon="warning"></span> No indicators available</td>
              </tr>
            } @else {
              @for (value of layer.values; track $index) {
                <!-- industrial sites excess heat under 100 has value NULL -->
                @if (value.value !== null) {
                  <tr class="value-row">
                    <td>{{ value.name | businessNameIndicators }}</td>
                    <td>
                      @if (cmSessionService.isNumber(value.value)) {
                        {{ value.value | number: '1.0-2' | numberformat }}
                        {{ value.unit | businessNameIndicators }}
                      } @else if (value.value == 'nan') {
                        -
                      } @else {
                        {{ value.value }}
                      }
                    </td>
                  </tr>
                }
              }
            }
          }
        } @else if (
          activeCMSessions$().length === 0 && !isLayerResultsLoading$() && !isCMRunning$()
        ) {
          <tr class="no-indicators-row">
            <td colspan="2">No indicators available</td>
          </tr>
        }

        <!-- CM results -->
        @for (cmSession of activeCMSessions$(); track $index) {
          @if (
            selectedCategoryRef$() == 'overall' || selectedCategoryRef$() == 'Calculation module'
          ) {
            <tr class="title-row">
              <td colspan="2">
                {{ cmSession.results.name }} - {{ cmSession.session_name }}
                <div class="info-cm-selection">
                  CM results values are fixed at the time of the run. The selection on the map does
                  not affect the numbers displayed in this tab.
                </div>
              </td>
            </tr>

            @for (value of cmSession.results.indicators; track $index) {
              @if (value.value !== null) {
                <tr class="value-row">
                  <td>{{ value.name | businessNameIndicators }}</td>
                  <td>
                    @if (cmSessionService.isNumber(value.value)) {
                      {{ value.value | number: '1.0-2' | numberformat }}
                      {{ value.unit | businessNameIndicators }}
                    } @else if (value.value == 'nan') {
                      -
                    } @else {
                      {{ value.value }}
                    }
                  </td>
                </tr>
              }
            }
          }
        }
      </table>
    }

    <!-- CHARTS -->
    @if (tabSelected$() === tabCharts) {
      @if (selectedCategoryRef$() == 'overall' || selectedCategoryRef$() == 'Calculation module') {
        @for (cmSession of activeCMSessions$(); track $index) {
          @for (graphic of cmSession.results.graphics; track $index) {
            @if (graphic != null) {
              <div class="cm-session-name">
                {{ cmSession.results.name }} - {{ cmSession.session_name }}
              </div>
              <app-chart [chartConfig]="graphic"></app-chart>
            }
          }
        }
      }
      @for (layer of filteredLayers$(); track $index) {
        @for (graphic of layer.graphics; track $index) {
          @if (graphic != null) {
            <div class="cm-session-name">
              {{ layer.name | businessNameLayer }}
            </div>
            <app-chart [chartConfig]="graphic"></app-chart>
          }
        }
      }
    }
  </div>
</div>

<app-export-data [tabSelected]="tabSelected$()"></app-export-data>
